import { ComponentProps } from 'react';
import classNames from 'classnames';
import { NoSsr } from '@material-ui/core';
import { Context } from 'types/Context';
import useAdaChatbot from 'hooks/useAdaChatbot';
import AdaChatbot from '@alltrails/shared/components/AdaChatbot';
import useExperiments from 'hooks/useExperiments';
import * as styles from './styles/styles.module.scss';
import LogoLink from './LogoLink';
import Dropdowns from './Dropdowns';
import UserCTA from './UserCTA';
import ConditionalRenderer from './ConditionalRender';
import MobileMenu from './MobileMenu';
import { HeaderBackground } from './types';
import SearchBox from './SearchBox';
import SkipToMainContentButton from './SkipToMainContentButton';

// https://www.figma.com/design/uArl1Yn1JPudAlXAqYFGs5/Global-Nav-[Handoff]?node-id=63-5827&t=2hSsVfor4WO27vQn-0

type NavigationHeaderProps = {
  background?: HeaderBackground;
  bottomBorder?: boolean;
  className?: string;
  context: Context;
  edgeToEdge?: boolean;
  hideSearch?: boolean;
} & ComponentProps<typeof SearchBox>;

const NavigationHeader = ({
  background = 'primary',
  bottomBorder,
  className,
  context,
  edgeToEdge,
  hideSearch,
  placeholder
}: NavigationHeaderProps) => {
  const experiments = useExperiments();
  const isAdaExperimentTreatmentActive = experiments?.['web-growth-rm-global-ada-chatbot-support']?.value === 'treatment';
  const { isAdaReady, config } = useAdaChatbot(isAdaExperimentTreatmentActive);

  return (
    <header
      className={classNames(
        styles.header,
        styles[background],
        {
          [styles.bottomBorder]: bottomBorder,
          [styles.edgeToEdge]: edgeToEdge
        },
        className
      )}
    >
      <SkipToMainContentButton />
      <nav className={styles.nav}>
        <div className={styles.left}>
          <LogoLink background={background} />
        </div>
        {!hideSearch ? <SearchBox placeholder={placeholder} /> : null}
        <div className={styles.right}>
          <NoSsr>
            <ConditionalRenderer renderWhen="mobile">
              <MobileMenu />
            </ConditionalRenderer>
            <ConditionalRenderer renderWhen="desktop">
              <Dropdowns background={background} />
              <UserCTA background={background} context={context} />
            </ConditionalRenderer>
          </NoSsr>
          {isAdaReady && <AdaChatbot config={config} experiment />}
        </div>
      </nav>
    </header>
  );
};
export default NavigationHeader;
